const autoSubmit = (submitForm, fakeDelay = 500) =>
  setTimeout(() => {
    submitForm()
  }, fakeDelay)

export const submitOnChange = autoSubmit
